import { generateSlug } from '@/lib/utils';
import { Bitcoiner, Author, Book, Person } from '@/types';

export async function fetchBooks(): Promise<Book[]> {
  const response = await fetch('/api/books');
  
  if (!response.ok) {
    console.error('Books API Error:', response.statusText);
    return [];
  }

  const data = await response.json();
  return data;
}

export async function fetchAuthors(): Promise<Author[]> {
  const response = await fetch('/api/authors');
  
  if (!response.ok) {
    console.error('Authors API Error:', response.statusText);
    return [];
  }

  const data = await response.json();
  return data;
}

export async function fetchPeople(): Promise<Person[]> {
  console.log('Debug - Starting fetchPeople...');
  const response = await fetch('/api/people');
  
  if (!response.ok) {
    console.error('People API Error:', response.statusText);
    return [];
  }

  const data = await response.json();
  return data;
}

export const fetchTweets = async () => {
  try {
    const response = await fetch('/api/tweets');
    if (!response.ok) {
      const error = await response.text();
      console.error('Tweets API Error:', error);
      return [];
    }
    const data = await response.json();
    if (!Array.isArray(data)) {
      console.error('Invalid tweets response:', data);
      return [];
    }
    return data;
  } catch (error) {
    console.error('Error fetching tweets:', error);
    return [];
  }
};